let ProjectConfig = {
  app: 'zed',
  api_prefix: '/zed-api',
  login_token_key: 'ZedV4-Token',
  login_user_key: 'ZedV4-USER',
  doc_path: '/zed-doc/index.html',
  logo_path: '/images/logos/logo.svg',
  main_site: 'https://www.baidu.com',
  footer: 'zed群控框架',
  copyRight: '2023 weijia.deng',
};

export default {
  ...ProjectConfig,
  wsBase: () => {
    let wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return (
      wsProtocol +
      '//' +
      window.location.host +
      ProjectConfig.api_prefix +
      '/ws/'
    );
  },
};
